import { readable, type Readable } from "svelte/store";

/**
 * Returns a store that can be used to match for CSS media queries.
 *
 * Try not to use this store in places other than the top-level. If you place
 * this in a component that is rendered multiple times, each instance will have
 * its own event listener.
 *
 * You can place this in the `<script context="module">` block of a Svelte file
 * to reduce duplicated event listeners.
 */
export function mediaQueryStore(query: string): Readable<boolean> {
  if (typeof window === "undefined") return readable(false);

  const mediaQuery = window.matchMedia(query);
  const store = readable(mediaQuery.matches, (set) => {
    const handler = (event: MediaQueryListEvent) => set(event.matches);
    mediaQuery.addEventListener("change", handler);
    return () => {
      mediaQuery.removeEventListener("change", handler);
    };
  });

  return store;
}
